import type { TemplateViewT } from 'src/ui/Template';
import type { ITemplateFields } from '@mentimeter/content-contentful/legacy/types/generated/contentful';

export const getTemplateProps = ({
  title,
  presentationId,
  questionId,
  preview,
}: ITemplateFields): TemplateViewT => ({
  title,
  presentationId,
  questionId,
  preview: preview?.fields?.file.url,
});
